import { Box, Button, Container, FormLabel, Heading, Input ,Textarea, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const ContactPage = () => {
    const [name,setName]=useState();
    const [email,setEmail]=useState();
    const [message,setMessage]=useState();
  return (
    <Container h='92vh'>
        <VStack h='full' justifyContent={'center'} spacing='16'>
            <Heading children='Contact Us' />
            <form style={{width:'100%'}}>
                <Box my={'4'}>
                <FormLabel htmlFor='name' children='Your Name'/>
                <Input required id='name' value={name} onChange={(e)=>setName(e.target.value)} placeholder='ok' type='text' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'4'}>
                <FormLabel htmlFor='email' children='Email Address'/>
                <Input required id='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='ok123@gmail.com' type='email' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'4'}>
                <FormLabel htmlFor='message' children='Message'/>
                <Textarea required id='message' value={message} onChange={(e)=>setMessage(e.target.value)} placeholder='Message for us' type='text' focusBorderColor='yellow.500' />
                </Box>
                <Button my='4' colorScheme={'yellow'} type='Submit'>Send Message</Button>
                <Box my='4'>
                    Want a new course ?<Link to="/request"><Button colorScheme={'yellow'} variant='link'>Request here</Button></Link>
                </Box>
            </form>
        </VStack>
    </Container>
  )
}

export default ContactPage